/* Hollow home enhancements. Product identities and prices come from Shopify Liquid. */
(() => {
  if (!customElements.get('hollow-product-card')) {
    customElements.define('hollow-product-card', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.mobileIndex = 0;
        this.querySelectorAll('[data-hollow-variant]').forEach(button => {
          button.setAttribute('aria-pressed', String(button.classList.contains('is-active')));
          button.addEventListener('click', event => {
            event.preventDefault();
            this.querySelectorAll('[data-hollow-variant]').forEach(other => {
              const active = other === button;
              other.classList.toggle('is-active', active);
              other.setAttribute('aria-pressed', String(active));
            });
            this.querySelectorAll('.js-product-link').forEach(link => { link.href = button.dataset.variantUrl; });
            this.querySelectorAll('.js-current-price').forEach(price => { price.textContent = button.dataset.variantPrice; });
            if (button.dataset.variantImage) this.querySelectorAll('.hollow-card-product-image').forEach(img => {
              img.removeAttribute('srcset');
              img.src = button.dataset.variantImage;
            });
            if (button.dataset.variantBackground) this.querySelectorAll('.hollow-card-background-image').forEach(img => {
              img.removeAttribute('srcset');
              img.src = button.dataset.variantBackground;
            });
            this.querySelectorAll('.js-variant-badge-pill').forEach(badge => {
              badge.textContent = button.dataset.variantBadge;
              badge.title = button.dataset.variantBadge;
              badge.hidden = !button.dataset.variantBadge;
            });
            this.showMedia(this.mobileIndex);
          }, options);
        });
        this.querySelectorAll('[data-collection-mobile-dot]').forEach(button => button.addEventListener('click', event => {
          event.preventDefault();
          this.showMedia(Number(button.dataset.collectionMobileDot));
        }, options));
        const media = this.querySelector('.hollow-card-mobile-media');
        if (media) {
          let start = null;
          let dragged = false;
          const matchesPointer = event => start && start.id === event.pointerId;
          const isHorizontalSwipe = event => {
            const dx = event.clientX - start.x, dy = event.clientY - start.y;
            return Math.abs(dx) >= 32 && Math.abs(dx) > Math.abs(dy);
          };
          const releasePointer = () => {
            if (start && media.hasPointerCapture?.(start.id)) media.releasePointerCapture(start.id);
            start = null;
          };
          media.addEventListener('dragstart', event => event.preventDefault(), options);
          media.addEventListener('pointerdown', event => {
            if (event.isPrimary === false || (event.pointerType === 'mouse' && event.button !== 0)) return;
            start = { x: event.clientX, y: event.clientY, id: event.pointerId };
            dragged = false;
          }, options);
          window.addEventListener('pointermove', event => {
            if (matchesPointer(event) && isHorizontalSwipe(event) && !media.hasPointerCapture?.(event.pointerId)) {
              media.setPointerCapture?.(event.pointerId);
            }
          }, options);
          window.addEventListener('pointerup', event => {
            if (!matchesPointer(event)) return;
            const swiped = isHorizontalSwipe(event);
            releasePointer();
            if (swiped) { dragged = true; this.showMedia(this.mobileIndex === 0 ? 1 : 0); }
          }, options);
          window.addEventListener('pointercancel', event => {
            if (matchesPointer(event)) releasePointer();
          }, options);
          media.addEventListener('click', event => { if (dragged) {event.preventDefault(); dragged=false;} }, options);
        }
      }
      showMedia(index) {
        this.mobileIndex=index;
        this.querySelectorAll('[data-collection-mobile-bg]').forEach(img=>img.classList.toggle('is-active',Number(img.dataset.collectionMobileBg)===index));
        this.querySelectorAll('[data-collection-mobile-card]').forEach(img=>img.classList.toggle('is-active',Number(img.dataset.collectionMobileCard)===index));
        this.querySelectorAll('[data-collection-mobile-dot]').forEach(button=>{
          const active=Number(button.dataset.collectionMobileDot)===index;
          button.classList.toggle('is-active',active);button.setAttribute('aria-pressed',String(active));
        });
      }
      disconnectedCallback() { this.abort?.abort(); }
    });
  }
  if (!customElements.get('hollow-home-carousel')) {
    customElements.define('hollow-home-carousel', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.track = this.querySelector('.splide__track');
        this.list = this.querySelector('.splide__list');
        this.querySelectorAll('[data-hollow-clone]').forEach(slide => slide.remove());
        this.slides = [...this.list.children];
        this.slides.forEach((slide, index) => { slide.dataset.hollowSlide = index; });
        const cloneSlide = slide => {
          const clone = slide.cloneNode(true);
          clone.dataset.hollowClone = '';
          clone.setAttribute('aria-hidden', 'true');
          clone.setAttribute('inert', '');
          clone.removeAttribute('id');
          clone.querySelectorAll('[id]').forEach(element => element.removeAttribute('id'));
          clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(element => element.tabIndex = -1);
          return clone;
        };
        if (this.slides.length > 1) {
          this.list.prepend(...this.slides.map(cloneSlide));
          this.list.append(...this.slides.map(cloneSlide));
        }
        this.loopSlides = [...this.list.children];
        this.classList.add('is-initialized', 'is-active');
        this.setAttribute('role', 'region');
        this.setAttribute('aria-label', 'Hollow photo gallery');
        this.track.tabIndex = 0;
        this.index = 0;
        this.visible = false;
        this.hovered = false;
        this.focused = this.contains(document.activeElement);
        this.dragging = false;
        this.touching = false;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.centered = matchMedia('(min-width: 768px)');
        this.addEventListener('mouseenter', () => { this.hovered = true; this.stop(); }, options);
        this.addEventListener('mouseleave', () => { this.hovered = false; this.start(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.stop(); }, options);
        this.addEventListener('focusout', event => {
          if (!this.contains(event.relatedTarget)) { this.focused = false; this.start(); }
        }, options);
        this.track.addEventListener('dragstart', event => event.preventDefault(), options);
        this.track.addEventListener('touchstart', () => {
          this.touching = true;
          this.stop();
        }, { ...options, passive: true });
        const finishTouch = event => {
          if (!this.touching || event.touches.length) return;
          this.touching = false;
          this.settleSoon();
          this.start();
        };
        window.addEventListener('touchend', finishTouch, { ...options, passive: true });
        window.addEventListener('touchcancel', finishTouch, { ...options, passive: true });
        this.track.addEventListener('pointerdown', event => {
          if (event.isPrimary === false || (event.pointerType === 'mouse' && event.button !== 0)) return;
          this.dragging = true;
          this.stop();
          this.pointer = { id: event.pointerId, x: event.clientX, y: event.clientY, left: this.track.scrollLeft, moved: false, native: event.pointerType === 'touch' };
          if (!this.pointer.native) event.preventDefault();
        }, options);
        window.addEventListener('pointermove', event => {
          const pointer = this.pointer;
          if (!pointer || pointer.id !== event.pointerId || pointer.native) return;
          const dx = event.clientX - pointer.x, dy = event.clientY - pointer.y;
          if (!pointer.moved && (Math.abs(dx) < 4 || Math.abs(dx) <= Math.abs(dy))) return;
          if (!pointer.moved) {
            pointer.moved = true;
            this.track.classList.add('is-dragging');
            this.track.setPointerCapture?.(event.pointerId);
          }
          event.preventDefault();
          this.track.scrollLeft = pointer.left - dx;
        }, options);
        const finishDrag = event => {
          const pointer = this.pointer;
          if (!pointer || pointer.id !== event.pointerId) return;
          this.pointer = null;
          this.dragging = false;
          const nearest = this.nearestSlide();
          this.track.classList.remove('is-dragging');
          if (this.track.hasPointerCapture?.(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
          if (pointer.moved && nearest) {
            this.track.scrollTo({ left: this.targetFor(nearest), behavior: this.motion.matches ? 'instant' : 'smooth' });
          }
          this.settleSoon();
          this.start();
        };
        window.addEventListener('pointerup', finishDrag, options);
        window.addEventListener('pointercancel', finishDrag, options);
        this.track.addEventListener('keydown', event => {
          if (event.altKey || event.ctrlKey || event.metaKey) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
          }
        }, options);
        this.track.addEventListener('scroll', () => {
          this.updateIndex();
          this.settleSoon();
        }, { ...options, passive: true });
        this.track.addEventListener('scrollend', () => this.normalizeLoop(), options);
        document.addEventListener('visibilitychange', () => document.hidden ? this.stop() : this.start(), options);
        this.motion.addEventListener('change', () => { this.normalizeLoop(); this.start(); }, options);
        this.centered.addEventListener('change', () => this.realign(), options);
        this.realign();
        if (window.ResizeObserver) {
          this.resizeObserver = new ResizeObserver(() => this.realign());
          this.resizeObserver.observe(this.track);
        }
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.visible ? this.start() : this.stop();
        });
        this.observer.observe(this);
      }
      targetFor(slide) {
        const center = this.centered.matches ? (this.track.clientWidth - slide.offsetWidth) / 2 : 0;
        return slide.offsetLeft - this.loopSlides[0].offsetLeft - center;
      }
      nearestSlide() {
        return this.loopSlides.reduce((nearest, slide) => Math.abs(this.targetFor(slide) - this.track.scrollLeft) < Math.abs(this.targetFor(nearest) - this.track.scrollLeft) ? slide : nearest, this.loopSlides[0]);
      }
      updateIndex() {
        const slide = this.nearestSlide();
        if (slide) this.index = Number(slide.dataset.hollowSlide);
      }
      jump(left) {
        this.track.scrollTo({ left, behavior: 'instant' });
      }
      realign() {
        const slide = this.slides[this.index];
        if (slide) this.jump(this.targetFor(slide));
      }
      settleSoon() {
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(() => this.normalizeLoop(), 180);
      }
      normalizeLoop() {
        clearTimeout(this.settleTimer);
        if (this.dragging || this.touching || !this.slides.length) return;
        const nearest = this.nearestSlide();
        if (nearest?.hasAttribute('data-hollow-clone')) {
          const original = this.slides[Number(nearest.dataset.hollowSlide)];
          this.jump(this.track.scrollLeft + original.offsetLeft - nearest.offsetLeft);
        }
        this.updateIndex();
      }
      go(index) {
        if (!this.slides.length) return;
        const direction = Math.sign(index - this.index);
        const logical = (index + this.slides.length) % this.slides.length;
        const candidates = this.loopSlides.filter(slide => Number(slide.dataset.hollowSlide) === logical);
        const current = this.track.scrollLeft;
        const directional = candidates.filter(slide => direction < 0 ? this.targetFor(slide) < current - 1 : this.targetFor(slide) > current + 1);
        const target = (directional.length ? directional : candidates).reduce((nearest, slide) => Math.abs(this.targetFor(slide) - current) < Math.abs(this.targetFor(nearest) - current) ? slide : nearest);
        this.index = logical;
        this.track.scrollTo({ left: this.targetFor(target), behavior: this.motion.matches ? 'instant' : 'smooth' });
      }
      start() {
        this.stop();
        if (this.visible && !this.hovered && !this.focused && !this.dragging && !this.touching && !this.motion.matches && !document.hidden && this.slides.length > 1) {
          this.timer = setInterval(() => this.go(this.index + 1), Number(this.dataset.interval) || 3000);
        }
      }
      stop() { clearInterval(this.timer); }
      disconnectedCallback() {
        this.stop();
        clearTimeout(this.settleTimer);
        this.touching = false;
        this.abort?.abort();
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
      }
    });
  }
})();
